import { getLatestEvent } from '../../../../utilities'

export const getLatestEventDate = session => {
  const latest = getLatestEvent(session, session.session)
  return latest ? new Date(latest.date) : new Date(0)
}
